module.exports = __webpack_public_path__ + "08b339237252c2dc0a4b66cea196f88b.pdf";